import action from "../../actionTypes";

export const generalModalsDefaultState = {
  errorModal: {
    isVisible: false
  }
};

const initialState = {
  errorModal: generalModalsDefaultState.errorModal
};

const generalModalsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case action.BOOKING_ERROR_MODAL:
      return { ...state, errorModal: payload };
    default:
      return state;
  }
};

export default generalModalsReducer;
